import { render } from "./PWABanner.vue?vue&type=template&id=3d8dc621&scoped=true"
import script from "./PWABanner.vue?vue&type=script&lang=js"
export * from "./PWABanner.vue?vue&type=script&lang=js"

import "./PWABanner.vue?vue&type=style&index=0&id=3d8dc621&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8dc621"]])

export default __exports__